module.exports = __webpack_public_path__ + "img/front_1.6d9940c1.svg";